module.exports = __webpack_public_path__ + "media/images/cheminée-29b62e9a5a78393a50f5a48506133706.svg";